export default __webpack_public_path__ + "static/media/Upload.c6f9f718.svg";